import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ProfileService } from "src/app/dashboard/services/profile.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-user-bank-account",
  templateUrl: "./user-bank-account.component.html",
  styleUrls: ["./user-bank-account.component.css"],
})
export class UserBankAccountComponent implements OnInit {
  bankaccountForm: FormGroup;
  isLoading: boolean = false;

  bankaccounts: {
    bankname: string;
    account_holder_name: string;
    country?: string;
    account_number: string;
    ifsc_code?: string;
    swift_code?: string;
    bank_details?: string;
  }[] = [];

  constructor(private profile: ProfileService) {}

  ngOnInit() {
    this.bankaccountForm = new FormGroup({
      bankname: new FormControl(null, [Validators.required]),
      account_holder_name: new FormControl(null, [Validators.required]),
      // country: new FormControl(null),
      // bank_details: new FormControl(null),
      account_number: new FormControl(null, [Validators.required]),
      // swift_code: new FormControl(null),
      // ifsc_code: new FormControl(null),
    });

    this.getBankaccounts();
  }

  addBankaccount() {
    this.isLoading = true;

    let formData: {
      bankname: string;
      account_holder_name: string;
      country?: string;
      account_number: string;
      ifsc_code?: string;
      swift_code?: string;
      bank_details?: string;
    } = {
      bankname: this.bankaccountForm.value.bankname,
      account_holder_name: this.bankaccountForm.value.account_holder_name,
      account_number: this.bankaccountForm.value.account_number,
      // country: this.bankaccountForm.value.country,
      // ifsc_code: this.bankaccountForm.value.ifsc_code,
      // swift_code: this.bankaccountForm.value.swift_code,
      // bank_details: this.bankaccountForm.value.bank_details,
    };

    this.profile.addBankaccount(formData).subscribe(
      (response) => {
        this.bankaccounts = response.data;
        this.isLoading = false;
        Swal.fire("", "Bank account added", "success");
        this.bankaccountForm.reset();
        this.getBankaccounts();
      },
      (error) => {
        this.isLoading = false;
        Swal.fire("", "Unable to add bank account", "warning");
        this.bankaccountForm.reset();
      }
    );
  }

  getBankaccounts() {
    this.profile.getUserBankaccounts().subscribe((response) => {
      this.bankaccounts = response.data;
    });
  }
}
